import React from "react";
 
const Footer = () => {
    const currentYear = new Date() .getFullYear();
    return (
        <footer className="footer mt-auto text-center text-xl-start">
            <span>&copy; Copyright {currentYear} Laundry Go Ltd. | All Rights Reserved.</span>
            </footer>
    );
};
 
export default Footer;